import { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ImageWithReservedSpace from 'components/Common/ImageWithReservedSpace'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import Heading from 'LuxKit/Typography/Heading'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import Places from 'constants/places'
import { useLocalizedPlaces } from 'hooks/usePlace'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'

const Root = styled.div`
  max-width: 100%;
`

const LocationLink = styled(ClickableLink)`
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
  width: 100%;
  min-width: ${rem(200)};
  width: ${rem(220)};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
  ${mediaQueryUp.tablet} {
    width: ${rem(366)};
  }
`

const LocationName = styled(Heading)`
  padding: ${rem(20)} 0;
`

const locations = [{
  placeId: Places.Bali.id,
  image: 'hx3vgckxkcrtwzwvbqfs',
  url: '/hotels/location/bali/indonesia',
}, {
  placeId: Places.Maldives.id,
  image: 'rxi3o9jzsiwju5o44tne',
  url: '/hotels/country/maldives',
}, {
  placeId: Places.Thailand.id,
  image: 'nbex3gjaeq2df9re8641',
  url: '/hotels/country/thailand',
}]

function ReferralTopLocations() {
  const placeIds = useMemo(() => locations.map(location => location.placeId), [])
  const localizedPlaces = useLocalizedPlaces(placeIds)

  return (
    <Root>
      <CardCarousel pageSize={3}>
        {locations.map(item => {
          const localized = localizedPlaces[item.placeId]
          const locationName = localized?.place?.name
          const isLoading = localized?.isLoading ?? true

          return (
            <LocationLink to={item.url} key={item.url}>
              <ImageWithReservedSpace
                mobileWidth="220px"
                tabletWidth="473px"
                alt={locationName ?? ''}
                id={item.image}
                gravity="center"
                mobileAspectRatio="1.1"
                tabletAspectRatio="1.85"
              />
              <LocationName variant="heading5" align="center">
                {isLoading || !locationName ? <TextLoadingBox width={120} /> : locationName}
              </LocationName>
            </LocationLink>
          )
        })}
      </CardCarousel>
    </Root>
  )
}

export default ReferralTopLocations
